export default "/images/tabler_flag.svg?90ff76d38ef679a9640c92b1deba7d73";